import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/**
 * @author Jakub Gereg
 */


import { jsonConversions, SalesDashboardExcelFileDTOConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
export var SalesDashboardExcelFileLayer = function SalesDashboardExcelFileLayer() {
  var _this = this;

  _classCallCheck(this, SalesDashboardExcelFileLayer);

  this.findAll = function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _this2 = this;

      var response, files;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return api(CONSTANTS.API.ENDPOINTS.SALES_DASHBOARD_EXPORTED).get({
                responseType: 'json'
              });

            case 3:
              response = _context.sent;
              files = [];
              (response.data.result || []).map(function (file) {
                files.push(_this2.fileDTOConverter.toObject(file, jsonConversions));
              });
              return _context.abrupt("return", files);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              logger.error(_context.t0);
              return _context.abrupt("return", Promise.reject(_context.t0));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));
  };

  this.download = function (fileId) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return api(CONSTANTS.API.ENDPOINTS.SALES_DASHBOARD_EXPORTED_DOWNLOAD(fileId)).get({
                responseType: 'blob'
              });

            case 3:
              response = _context2.sent;
              return _context2.abrupt("return", Promise.resolve(response));

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              logger.error(_context2.t0);
              return _context2.abrupt("return", Promise.reject(_context2.t0));

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));
  };
};

__decorate([Inject, __metadata("design:type", SalesDashboardExcelFileDTOConverter)], SalesDashboardExcelFileLayer.prototype, "fileDTOConverter", void 0);